import { Mail, Instagram, MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { BRAND } from "../data/content";
import { useLang } from "../i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLang();

  return (
    <footer
      id="contatti"
      data-testid="footer"
      className="scroll-mt-20 bg-black border-t border-white/10 pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div className="md:col-span-1">
            <Logo className="h-14 w-auto text-[#C5A059] mb-4" strokeWidth={2.6} />
            <h3 className="font-serif text-2xl text-white">
              Ncc <span className="font-light italic">Bologna</span>
            </h3>
            <p className="mt-3 text-sm text-zinc-400 font-light leading-relaxed max-w-xs">
              {t.footer.desc}
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-5">
              {t.footer.serviziHeading}
            </h4>
            <ul className="space-y-3 text-sm text-zinc-300 font-light">
              {t.footer.serviziList.map((s, i) => (
                <li key={i}>{s}</li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-5">
              {t.footer.contattiHeading}
            </h4>
            <ul className="space-y-4 text-sm text-zinc-300">
              <li>
                <a
                  href={`mailto:${BRAND.email}`}
                  data-testid="footer-email"
                  className="flex items-center gap-3 hover:text-white transition-colors"
                >
                  <Mail className="h-4 w-4 text-[#C5A059]" />
                  {BRAND.email}
                </a>
              </li>
              <li>
                <a
                  href={BRAND.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram"
                  className="flex items-center gap-3 hover:text-white transition-colors"
                >
                  <Instagram className="h-4 w-4 text-[#C5A059]" />
                  @{BRAND.instagram}
                </a>
              </li>
              <li>
                <a
                  href={`https://wa.me/${BRAND.phoneHref.replace(/[^\d]/g, "")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp"
                  className="flex items-center gap-3 hover:text-white transition-colors"
                >
                  <MessageCircle className="h-4 w-4 text-[#C5A059]" />
                  {BRAND.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-zinc-500">
          <p>© {new Date().getFullYear()} Ncc Bologna · {t.footer.rights}</p>
          <p className="uppercase tracking-[0.2em]">{t.footer.slogan}</p>
        </div>
      </div>
    </footer>
  );
};
